module.exports = __webpack_public_path__ + "static/img/introduction-environmental-strategy-move-the-date.4415e87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/introduction-environmental-strategy-move-the-date.jpg
// module id = bBGj
// module chunks = 0